export default __webpack_public_path__ + "static/media/62.39eb223f.jpeg";